import { motion } from "framer-motion";
import { ClipboardCheck, ShieldCheck, Wrench, Rocket } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { useT, useLang } from "@/lib/i18n";

const ICONS = [ClipboardCheck, ShieldCheck, Wrench, Rocket];
const NUMS = ["01", "02", "03", "04"];

export function Journey({ onEnquire }) {
  const t = useT();
  const { lang } = useLang();
  const isHi = lang === "hi";
  const steps = t("journey.steps");

  return (
    <section className="relative py-16 md:py-24 border-t border-border">
      <div className="max-w-[90rem] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <SectionHeading
            index="—"
            overline={t("journey.overline")}
            title={
              isHi ? (
                <span className="font-hindi">{t("journey.titleA")}<span className="font-hindi">{t("journey.titleB")}</span></span>
              ) : (
                <>{t("journey.titleA")}<span className="font-display italic font-normal">{t("journey.titleB")}</span></>
              )
            }
            overlineClassName={isHi ? "font-hindi tracking-normal text-[12px]" : undefined}
          />
          <button onClick={onEnquire} className={`btn-pill-yellow self-start md:self-auto shrink-0 ${isHi ? "font-hindi" : ""}`}>
            {t("journey.cta")}
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={NUMS[i]}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="relative brochure-card bg-card border border-border card-hover flex flex-col gap-4 min-h-[220px]"
              >
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 grid place-items-center rounded-xl bg-[#FFCC00] text-black">
                    <Icon className="w-5 h-5" strokeWidth={1.8} />
                  </div>
                  <span className="font-mono text-3xl font-medium text-muted-foreground/40">{NUMS[i]}</span>
                </div>
                <div className="mt-auto">
                  <h3 className={`font-extrabold text-xl tracking-tight ${isHi ? "font-hindi" : "font-sans"}`}>{s.title}</h3>
                  <p className={`mt-2 text-sm text-muted-foreground leading-relaxed ${isHi ? "font-hindi" : ""}`}>{s.body}</p>
                </div>
                {i < steps.length - 1 && (
                  <span className="hidden lg:block absolute top-1/2 -right-2 w-4 h-px bg-border z-10" />
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
